import React from "react";
import { connect } from "react-redux";
import { NovelSettings } from "./controlsIcons";
import { NovelReadingControlsView } from "./NovelReadingControlsView";

function NovelReadingControls({ t, settingsUpdaters }) {
  const [optionsVisible, setOptionsVisible] = React.useState(false);
  function toggleOptionsVisible() {
    setOptionsVisible(state => !state);
  }
  return (
    <div className="a-reader-nav a-novel slide-in-left-0 " style={{ top: "100px" }}>
      <div className="relative ">
        <NovelSettings onClick={toggleOptionsVisible}>
          <span className="nav-label mt1">{t.settings}</span>
        </NovelSettings>
        {optionsVisible && (
          <NovelReadingControlsView
            t={t}
            settingsUpdaters={settingsUpdaters}
            onClose={toggleOptionsVisible}
          />
        )}
      </div>
    </div>
  );
}

const mapState = (state, _ownProps) => ({
  t: I18n.t("landing.scrollreader_novel_controls"),
  ...state.reading
});

export default connect(mapState)(NovelReadingControls);
